module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Little Cowpokes Cookbook")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yeehaw! A Recipe Roundup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast at the Ranch ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brown Sugar Mule Muffins ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggs Rancheros ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttermilk Flappin’ Flapjacks with\n                                    Blueberry Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit Pony Tails ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cowboy Kettle Cocoa ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cowpunchers Campout ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Range BBQ Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cactus Kabobs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saddle Up S’mores ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnny Cakes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e465",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fire-Roasted Cob Corn with Herb Butter\n                                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rodeo Refreshments ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e519",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buckin’ Bull Nachos with Avocado Salsa\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e565",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Along Pretzel Doggies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e609",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Churro Sundaes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e642",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whippersnapper Slush ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e668",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jamboree Krispy Pops ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chuck Wagon Dinner ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e722",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cooky’s Cole Slaw ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e756",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trail Ride Beans ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e790",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow-Cooked Smoky Brisket ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e820",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar and Honey Hot Rocks ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e850",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh-Squeezed Lemonade ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pioneer’s Pantry ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e886",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orchard Medley Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e913",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potatoes ’n’ Coats ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e958",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oven-Roasted Turkey with Kitchen Garden\n                                    Vegetables ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e995",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Tarts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pioneer Honey Taffy ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Western Grub ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Train Robbery Gold ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boot Hill Pudding Cups ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Sheet Cake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sheriff’s Sugar Cookies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e1261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild West Gingerbread House ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2835850b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 60
// module chunks = 0